import { z } from 'zod';
/** Каналы доставки. Telegram — один из транспортов, не единственный. */
export const notificationChannelSchema = z.enum(['TELEGRAM', 'WEBPUSH']);
export const NOTIFICATION_CHANNELS = ['TELEGRAM', 'WEBPUSH'];
/** Типы уведомлений. Настройки задаются по паре (тип, канал). */
export const notificationTypeSchema = z.enum(['WEEKLY_REPORT', 'SYSTEM']);
export const NOTIFICATION_TYPES = ['WEEKLY_REPORT', 'SYSTEM'];
/**
 * Канало-независимое содержимое уведомления. Транспорт сам решает, как это
 * показать: Telegram берёт `telegramHtml` (или собирает из title/body),
 * web push — title/body/url.
 */
export const notificationPayloadSchema = z.object({
    title: z.string().min(1).max(200),
    body: z.string().min(1),
    /** Куда ведёт клик по уведомлению — относительный путь внутри webapp. */
    url: z.string().optional(),
    /** Готовый HTML для Telegram, если текст канало-специфичный. */
    telegramHtml: z.string().optional(),
    /** Схлопывание однотипных пушей в браузере. */
    tag: z.string().optional(),
});
// ─── Web Push подписки ────────────────────────────────────────────────────────
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
    userAgent: z.string().max(500).optional(),
});
export const pushUnsubscribeSchema = z.object({
    endpoint: z.string().url(),
});
// ─── Настройки каналов ────────────────────────────────────────────────────────
export const notificationPreferenceSchema = z.object({
    type: notificationTypeSchema,
    channel: notificationChannelSchema,
    enabled: z.boolean(),
});
export const updateNotificationPreferencesSchema = z.object({
    preferences: z.array(notificationPreferenceSchema).min(1).max(50),
});
//# sourceMappingURL=notification.js.map